const locale = {
  UPSERT_TITLE_TEXT: 'Successfully added',
  UPSERT_DESCRIPTION_TEXT: 'This course is now in your collection.',
  ERROR_UPSERT_TITLE_TEXT: 'Couldn’t save course',
  ERROR_UPSERT_DESCRIPTION_TEXT: 'Something went wrong. Please try again.',
  VIEW_COURSES_LINK_TEXT: 'Go to Your Collections',
  VIEW_ALL_SAVED_COURSES_LINK_TEXT: 'Go to All Saved Courses',
  DELETE_TITLE_TEXT: 'Course removed',
  DELETE_DESCRIPTION_TEXT: 'This course is now out of your collections.',
  ERROR_TITLE_TEXT: 'Error',
  ERROR_DESCRIPTION_TEXT: 'Something went wrong please try again.',
  UNDO_ACTION_TEXT: 'Undo',
};

export default locale;
